import { bcrModalModeEnum } from './CommissionPage';

export const updateBrokerCostRateListAfterSave = (newRate, modalMode, brokerCostRates, setBrokerCostRates) => {
  const newMappedRate = mapBrokerCostRateAfterSave(newRate);
  if (modalMode === bcrModalModeEnum.createDefaultRate) {
    setBrokerCostRates([newMappedRate]);
  } else if (modalMode === bcrModalModeEnum.editCustomerRate) {
    const newBrokerCostRates = [];
    brokerCostRates.forEach(bcr => {
      if (bcr.customerNumber === newMappedRate.customerNumber) {
        newBrokerCostRates.push(newMappedRate);
      } else {
        newBrokerCostRates.push(bcr);
      }
    });
    setBrokerCostRates(newBrokerCostRates);
  } else if (modalMode === bcrModalModeEnum.newCustomerRate) {
    setBrokerCostRates([brokerCostRates[0], newMappedRate, ...brokerCostRates.slice(1)]);
  } else {
    setBrokerCostRates([newMappedRate, ...brokerCostRates.slice(1)]);
  }
};

export const getNewDefaultBcr = agentCode => {
  return {
    agentCode,
    useBrokerCost: false,
    useMotorCommission: false,
    usePersonalCommission: false,
    inheritCommissionHandling: false,
  };
};

export const calculateBrokerCostRatesToBeShown = (brokerCostRates, filteredCustomers) => {
  if (filteredCustomers.length > 0) {
    return [
      brokerCostRates[0],
      ...brokerCostRates.filter(bcr =>
        filteredCustomers.some(customer => customer.customerNumber === bcr.customerNumber)
      ),
    ];
  }

  return brokerCostRates;
};

const findCustomer = (customerNumber, customerSlimList) => {
  return customerSlimList.find(x => x.number === customerNumber);
};

export const getRate = (rates, rateType) => {
  return rates?.find(x => x.rateType === rateType)?.rate ?? '-';
};

/**
 * This method will sort the rate list, and set rates with inheritCommissionHandling selected to default rate
 */
export const convertApiResultForApp = (ratesDto, customerSlimList) => {
  const defaultRate = ratesDto.find(rate => !rate.customerNumber);
  let customerRates = ratesDto.filter(rate => rate.customerNumber);

  customerRates = customerRates.map(rate => {
    const customer = findCustomer(rate.customerNumber, customerSlimList);
    if (rate.inheritCommissionHandling) {
      return {
        ...defaultRate,
        inheritCommissionHandling: true,
        customerNumber: customer.number,
        customerName: customer.name,
        legalNumber: customer.legalNumber,
      };
    }
    return {
      ...rate,
      customerName: customer.name,
      legalNumber: customer.legalNumber,
    };
  });

  const sortedCustomerRates = customerRates.sort((a, b) => {
    if (a.inheritCommissionHandling !== b.inheritCommissionHandling) return a.inheritCommissionHandling ? 1 : -1;
    return a.customerName?.localeCompare(b.customerName) ?? 1;
  });
  return [defaultRate, ...sortedCustomerRates];
};

export const convertApiCustomerListForApp = customers => {
  return customers.map(x => {
    return { legalNumber: x.legalNumber, customerName: x.name, customerNumber: x.number };
  });
};

export const sortBrokerCostRatesWhoHaveCustomers = brokerCostRates => {
  brokerCostRates.sort((a, b) => {
    if (a.inheritCommissionHandling !== b.inheritCommissionHandling) return a.inheritCommissionHandling ? 1 : -1;
    return a.customerName?.localeCompare(b.customerName) ?? 1;
  });
};

export const mapBrokerCostRateAfterSave = brokerCostRate => {
  const date = new Date();
  return {
    ...brokerCostRate,
    effective: `${date.toISOString()}`,
    updated: `${date.toISOString()}`,
    expires: '2099-12-31T00:00:00',
    updatedBy: { sourceSystem: 'SalesAgentApp', userIdentifier: 'You' },
  };
};

export const updateScrollBarVisibility = (scrollbar, bcrTableContainer) => {
  const isOverflowing = bcrTableContainer.scrollWidth > bcrTableContainer.clientWidth;

  if (isOverflowing) {
    scrollbar.style.display = 'block';
  } else {
    scrollbar.style.display = 'none';
  }
};

export const updateScrollbarWidthAndLocation = (scrollbar, bcrTableContainer, observedRateContainer) => {
  if (!bcrTableContainer || !scrollbar) return;

  const rateContRect = bcrTableContainer.getBoundingClientRect();

  scrollbar.style.width = `${bcrTableContainer.offsetWidth}px`;

  if (window.innerHeight < observedRateContainer.contentRect.height) {
    scrollbar.style.bottom = `0px`;
  } else {
    scrollbar.style.bottom = `${window.innerHeight - rateContRect.y - rateContRect.height}px`;
  }

  const scrollbarContent = scrollbar.querySelector('.commission-page_scrollbar-content');
  if (scrollbarContent) {
    let scrollWidth = bcrTableContainer.scrollWidth;

    // for in case if history table takes more space than parent table
    const bcrHistoryContainer = bcrTableContainer.querySelector('.commission-page_history-table-container');
    if (bcrHistoryContainer) {
      scrollWidth = Math.max(scrollWidth, bcrHistoryContainer.scrollWidth);
    }

    scrollbarContent.style.width = `${scrollWidth}px`;
  }
};
